import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import BlockUI from "vue-blockui";
import Multiselect from 'vue-multiselect'
import LoadingPage from '@/components/Loading/LoadingPage.vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
// router setup
import router from "./routes/router";
import http from "./api/http.js";

Vue.prototype.$http = http;
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(BlockUI);

Vue.component('multiselect', Multiselect);
Vue.component('LoadingPage', LoadingPage);
/* eslint-disable no-new */

Vue.filter("number", function(value) {
  if (typeof value !== "number" || isNaN(value)) {
    return "0.00";
  }
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
});

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
